<template>
  <base-section id="gallery">
    <span class="trace">sections/Gallery.vue</span>

    <v-col
      class="intro"
      cols="12"
      sm="12"
      lg="12"
      xl="12"
    >
      Here you'll find all the projects that C.A.T. is currently either working on or considering.
    </v-col>

    <v-tabs
      v-model="tab"
      centered
      class="mb-12"
    >
      <v-tab
        v-for="(tab, i) in tabs"
        :key="i"
        :href="`#${tab.toLowerCase()}`"
        class="text-capitalize"
      >
        {{ tab }}
      </v-tab>
    </v-tabs>
    <!--
    {{ filteredProjects }}
    -->
    <v-container>
      <v-fade-transition
        group
        hide-on-leave
        tag="v-row"
      >
        <v-col
          v-for="project in filteredProjects"
          :key="project.title"
          class="gallery-card"
          cols="12"
          sm="6"
          lg="4"
          xl="3"
        >
          <!--
          v-for="(project, i) in filteredProjects"
            :src="require(myGraphic({project}))"
            :src="require(`@/assets/project-${i + 1}.jpg`)"
          <span class="trace">{{ project.grpahic+1 }}</span>

          PROJECT: {{ project }}
            :src="require(`@/assets/project-${project.idx + 1}.jpg`)"

            :to has the effect of a router push to the name

          -->

          <span class="trace">[{{ project.idx+1 }}]</span>
          <project-card
            v-bind="project"
            height="300"
            width="100%"
            :idx="project.idx"
            :graphic="project.graphic"
            :projectTitle="project.title"

            :to="{
              name: project.nn,
              params: { project: project.graphic, graph: project.graphic },
            }"
          />
        </v-col>
      </v-fade-transition>
      <v-col
        cols="12"
        class="intro"
      >
        * These are projects that are proposed but not yet active.
      </v-col>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionGallery',

    components: {
      ProjectCard: () => import('@/components/ProjectCard'),
    },

    data: () => ({
      tab: 'All',
      tabs: [
        'All',
        'Air',
        'Water',
        'Land',
        'Energy',
        'Fire',
        'CAT',
      ],
    }),

    computed: {
      projects () {
        return [
          { title: 'WATER QUALITY', subtitle: 'Water', graphic: 'waterQuality', nn: 'splashWQ' },
          { title: 'Home Energy Assessment', subtitle: 'Energy, Air', graphic: 'homeEnergyAssessment' },
          { title: 'SEPTIC SYSTEMS*', subtitle: 'Water', graphic: 'septicSystems' },
          { title: 'REFRIGERANTS*', subtitle: 'Air', graphic: 'refrigerants' },
          { title: 'CO2 EMISSIONS*', subtitle: 'Air', graphic: 'CO2Emissions' },
          { title: 'Electric Heat Pumps*', subtitle: 'Energy', graphic: 'miniSplits' },
          { title: 'Solar Panels*', subtitle: 'Energy', graphic: 'solarPanels' },
          { title: 'Heat Pump Water Heaters*', subtitle: 'Energy', graphic: 'heatPumpWaterHeaters' },
          { title: 'Electric Cars*', subtitle: 'Energy', graphic: 'electricCars' },
          { title: 'SOIL QUALITY*', subtitle: 'Land', graphic: 'soilQuality' },
          { title: 'Oil Furnaces*', subtitle: 'Energy, Air, Fire', graphic: 'oilFurnaces' },
          { title: 'Fire Prevention', subtitle: 'Fire', graphic: 'firePrevention' },
          { title: 'Communications', subtitle: 'CAT', graphic: 'communications' },
        ]
        /* .filter(project => {
          if (this.tab.toLowerCase() === 'all') return true
          if (project.subtitle.toLowerCase() === this.tab.toLowerCase()) return true
          if (project.subtitle.toLowerCase().includes(this.tab.toLowerCase())) return true
          return false
        })  */
      },

      filteredProjects () {
        // return this.projects
        const nArray = []
        let pp = {}
        for (let j = 0; j < this.projects.length; j++) {
          if (this.tab.toLowerCase() === 'all') {
            pp = this.projects[j]
            pp.idx = j // remember the index of the project
            nArray.push(pp)
            continue
          } else if (this.projects[j].subtitle.toLowerCase().includes(this.tab.toLowerCase())) {
            pp = this.projects[j]
            pp.idx = j
            nArray.push(pp)
            continue
          }
          continue
          // if (j % 2 === 0) continue

          // nArray.push(this.projects[j])
        }
        return nArray
      },

    },

    methods: {
      myGraphic: function (project) {
        if (project.graphic === undefined) return '../../../assets/project-' + '1' + '.jpg'
        return project.graphic
      },
    },

  }
</script>

<style lang="sass">
  .gallery-card
    transform-origin: center center 0
    transition: .3s cubic-bezier(.25,.8,.50,1)

  .intro
    transform-origin: center center 0
    transition: .3s cubic-bezier(.25,.8,.50,1)
    font-size: 90%
    margin-left: 170px
    color: gray
</style>
